import { render, staticRenderFns } from "./inquiry.html?vue&type=template&id=6669ec5c&scoped=true&"
import script from "./inquiry.vue?vue&type=script&lang=ts&"
export * from "./inquiry.vue?vue&type=script&lang=ts&"
import style0 from "./inquiry.scss?vue&type=style&index=0&id=6669ec5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6669ec5c",
  null
  
)

export default component.exports